import { combineReducers } from 'redux';

import auth from './auth/reducer';
import users from './users/reducer';
import profile from './profile/reducer';
import orders from './orders/reducer';
import videos from './videos/reducer';
import market from './market/reducer';
import transfer from './transfer/reducer';
import wallets from './wallets/reducer';
import referrals from './referrals/reducer';
import admins from './admins/reducer';
import projects from './projects/reducer';
import vacancies from './vacancies/reducer';
import traderInfo from './traderInfo/reducer';
import settings from './settings/reducer';
import fiatTransfer from './fiatTransfer/reducer';
import reset2FA from './reset2FA/reducer';
import cashback from './cashback/reducer';
import feesAndLimits from './feesAndLimits/reducer';
import tradeVolumeSettings from './tradeVolumeSettings/reducer';
import trades from './trades/reducer';
import chatModerators from './chatModerators/reducer';
import posts from './posts/reducer';
import vote from './vote/reducer';

export default combineReducers({
  auth,
  users,
  profile,
  orders,
  videos,
  market,
  transfer,
  wallets,
  referrals,
  admins,
  projects,
  vacancies,
  traderInfo,
  settings,
  fiatTransfer,
  reset2FA,
  cashback,
  feesAndLimits,
  tradeVolumeSettings,
  trades,
  chatModerators,
  posts,
  vote,
});
